import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { registerSW } from "virtual:pwa-register";

// Register service worker automatically on app start
// This is generated by VitePWA plugin when injectRegister is set to 'auto'
const updateSW = registerSW({
  onNeedRefresh() {
    console.log("[PWA] New content available, please refresh.");
  },
  onOfflineReady() {
    console.log("[PWA] App ready to work offline.");
  },
  onRegistered(registration) {
    console.log("[PWA] Service Worker registered:", registration);
  },
  onRegisterError(error) {
    console.error("[PWA] Service Worker registration error:", error);
  },
});

// Note: Push notification errors in development are expected and don't affect the Notification API functionality

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
